import { isButton, isCheckbox, isCheckboxGroup, isColor, isEnum, isGroup, isNumeric, isText, isMultiEnum } from "../../Models/SelectableDimensions/SelectableDimensions";
import Box from "../../Styled/Box";
import Spacing from "../../Styled/Spacing";
import Text from "../../Styled/Text";
import { parseCustomMarkdownToReactWithOptions } from "../Custom/parseCustomMarkdownToReact";
import { SelectableDimensionButton } from "./Button";
import { SelectableDimensionCheckbox } from "./Checkbox";
import { SelectableDimensionColor } from "./Color";
import { SelectableDimensionGroup } from "./Group";
import { SelectableDimensionNumeric } from "./Numeric";
import { SelectableDimensionEnum, SelectableDimensionEnumMulti as SelectableDimensionMultiEnum } from "./Select";
import { SelectableDimensionText } from "./Text";
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const SelectableDimension = _ref => {
  let {
    id,
    dim
  } = _ref;
  return /*#__PURE__*/_jsxs(Box, {
    displayInlineBlock: true,
    fullWidth: true,
    styledMargin: "0 0 5px 0",
    children: [dim.name && dim.type !== "group" ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("label", {
        htmlFor: id,
        children: /*#__PURE__*/_jsxs(Text, {
          textGreyLighter: true,
          medium: true,
          as: "span",
          children: [parseCustomMarkdownToReactWithOptions(dim.name, {
            inline: true
          }), ":"]
        })
      }), /*#__PURE__*/_jsx(Spacing, {
        bottom: 1
      })]
    }) : null, isCheckbox(dim) && /*#__PURE__*/_jsx(SelectableDimensionCheckbox, {
      id: id,
      dim: dim
    }), isEnum(dim) && /*#__PURE__*/_jsx(SelectableDimensionEnum, {
      id: id,
      dim: dim
    }), isMultiEnum(dim) && /*#__PURE__*/_jsx(SelectableDimensionMultiEnum, {
      id: id,
      dim: dim
    }), (isGroup(dim) || isCheckboxGroup(dim)) && /*#__PURE__*/_jsx(SelectableDimensionGroup, {
      id: id,
      dim: dim
    }), isNumeric(dim) && /*#__PURE__*/_jsx(SelectableDimensionNumeric, {
      id: id,
      dim: dim
    }), isText(dim) && /*#__PURE__*/_jsx(SelectableDimensionText, {
      id: id,
      dim: dim
    }), isButton(dim) && /*#__PURE__*/_jsx(SelectableDimensionButton, {
      id: id,
      dim: dim
    }), isColor(dim) && /*#__PURE__*/_jsx(SelectableDimensionColor, {
      id: id,
      dim: dim
    })]
  });
};
export default SelectableDimension;